import React, { useState, useContext, useMemo,useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UploadDocument from "./UploadDocument";
import UserService from "../../services/UserService";
import axios from "axios";
import {getDataFiles, getAccountTemplates} from "services/ConfigServices"

export default function useEntitesTable() {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState({});
  const [refresh, setRefresh] = useState(false);
  const url = getDataFiles(chartIdGroup);
  const [loading, setLoading] = useState(false);
  const [accountTemplates, setAccountTemplates] = useState([]);

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") 
    {
      if((prevIdGroup && prevIdGroup === chartIdGroup)
      && (prevRefresh && prevRefresh === refresh))
      {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,        
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup,refresh]);

  useEffect(()=> {
    axios
    .get(
      getAccountTemplates(chartIdGroup),
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((res) => {
      if (res.status == 200) {
        setAccountTemplates(res.data);
      }
    });
  },[chartIdGroup])

  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const StyledTextField = styled.input`
    height: 32px;
    width: 200px;
    border-radius: 3px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid #e5e5e5;
    padding: 0 32px 0 16px;
    &:hover {
      cursor: text;
    }
  `;

  const ClearButton = styled.button`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    height: 34px;
    width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
  `;

  const UploadButton = styled.div`
    margin-left: 15px;
    &:hover {
      cursor: pointer;
    }
  `;

  const TableName = styled.h1`
    margin-right: auto;
    margin-left: -8px;
    font-size: 1.3rem;
    font-weight: 500;
  `;

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const refreshTable = () =>
  {
    setRefresh(!refresh);
  }

  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        <UploadDocument refetch={refreshTable} accountTemplates={accountTemplates}/>
      </UploadButton>
    </>
  );

  const [openModal, setOpenModal] = useState(false);
  const handleClickOpen = () => {
    setOpenModal(true);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  const filteredItems = _.get(results, "collection", []).filter(
    (item) =>
      (item.fileName &&
        item.fileName.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.importGroupName &&
        item.importGroupName
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.importType &&
        item.importType.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.importUser &&
        item.importUser.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <TableName>Import de données</TableName>
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        <UploadComponent key="UploadComponent" onUpload={handleClear} />
      </>
    );
  }, [filterText, resetPaginationToggle, accountTemplates]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
      loading,
    },
    refetch: refreshTable
  };
}
